import * as React from "react";
import LayerAPI from "./LayerAPI";
export default function Layer(_a) {
    var render = _a.render, transitionExit = _a.transitionExit, _b = _a.context, context = _b === void 0 ? LayerAPI : _b;
    var key = React.useRef();
    React.useEffect(function () {
        key.current = context.pushLayer(render);
        return function () {
            if (transitionExit === true) {
                context.transitionExitLayer(key.current);
            }
            else {
                context.removeLayer(key.current);
            }
        };
    }, []);
    React.useEffect(function () {
        context.updateLayer(key.current, render);
    }, [render]);
    return null;
}
